<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      СП РК 3.05-103-2014<br>
      ВСН 478-86<br>
      Форма 7
    </div>
    <div class="chapter-title">Сведения по п. 2.2 ВСН <br>Журнал <br> учета и проверки качества контрольных (пробных) сварных соединений</div>
    <n-items v-if="project">
      <n-input title="(Сварочная лаборотория и её принадлежность)" v-bind="$form.input('weldLab')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
